<script>
  import { _ } from 'svelte-i18n'
  import { modals, user } from '../../stores'
  import { toggleSmartCategoriesOn } from '../../services/user';
  import { getFontClassificationsFromDB } from '../../services/fonts';
  import Modal from '../../elements/Modal.svelte'
  import Button from '../../elements/Button.svelte';

  let modal_id = 'smartCategories'
  
  const handleClick = async () => {
    const response = await toggleSmartCategoriesOn(true)
    if (response.data === true) {
      $user.feature_ai_categories_on = true
      getFontClassificationsFromDB()
      modals.close()
    }
  }
</script>

<Modal id={modal_id} medium={true}>
  <span slot="header">
    {$_('modals.enableSmartCategories.title')}
  </span>
  <span class="content" slot="content">
    {@html $_('modals.enableSmartCategories.content')}
    <div class="note">
      {@html $_('modals.enableSmartCategories.note')}
    </div>
    <Button on:click={handleClick}>{$_('modals.enableSmartCategories.button')}</Button>
  </span>
</Modal>

<style>
  .content {
    display: inline-block;
    margin-bottom: 1rem;
  }
  .note {
    margin: 2rem 0 3rem;
  }
</style>